// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2Ra9x","alertIcon":"ConfirmModal_alertIcon__2N-9B"};